import { render, staticRenderFns } from "./PasswordRecoveryView.vue?vue&type=template&id=183fcd95&lang=pug"
import script from "./PasswordRecoveryView.vue?vue&type=script&lang=ts"
export * from "./PasswordRecoveryView.vue?vue&type=script&lang=ts"
import style0 from "./PasswordRecoveryView.vue?vue&type=style&index=0&id=183fcd95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VForm,VRow,VTextField})
